//Iphone 5
export const SMALL_MOBILE = '320px';
export const MOBILE = '767px';
export const MOBILE_SPOE = '991px';
export const BELOW_MEDIUM_DESKTOP = '991px';
